import { useMemo } from 'react';
import {useConnection} from '../connections/useConnection';
import {useEvent} from '../eventHooks';
import { last, sortBy } from 'lodash';

export function useLastCommonEvent(userId) {
    const connection = useConnection(userId),
        {events_connected = []} = connection ?? {},
        lastEvent = useMemo(() => {
            return last(sortBy(events_connected, 'start'));
        }, [events_connected]);

    return useEvent(lastEvent?.id);
}
